var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"alpha"},[_vm._v("About Law Firm Tasks")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }